import { useState } from 'react';
import SectionHeading from './SectionHeading';
import { troubleshootItems } from '@/mocks/home';

export default function Troubleshoot() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="troubleshoot" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Troubleshooting"
          title="打不开？先按现象对号入座"
          desc="不同的「打不开」表现，原因往往不一样。找到与你最接近的一条展开，按给出的顺序一步步试，通常能定位到问题所在。"
        />

        <div className="mt-9 space-y-3">
          {troubleshootItems.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={item.symptom}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  isOpen ? 'border-primary-300 bg-background-50' : 'border-background-200 bg-background-50'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : idx)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left cursor-pointer md:px-5"
                >
                  <span className="flex items-center gap-3">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                      <i className="ri-flashlight-line"></i>
                    </span>
                    <span className="text-sm font-medium text-foreground-900 md:text-base">{item.symptom}</span>
                  </span>
                  <i
                    className={`ri-add-line shrink-0 text-lg text-foreground-500 transition-transform ${
                      isOpen ? 'rotate-45' : ''
                    }`}
                  ></i>
                </button>

                {isOpen && (
                  <div className="anim-fade border-t border-background-200 px-4 pb-5 pt-4 md:px-5 md:pl-[68px]">
                    <p className="text-sm text-foreground-600">
                      <span className="font-medium text-foreground-800">常见原因：</span>
                      {item.cause}
                    </p>
                    <ul className="mt-3 space-y-2">
                      {item.solutions.map((sol, i) => (
                        <li key={sol} className="flex gap-2.5 text-sm leading-relaxed text-foreground-700">
                          <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-[11px] font-semibold text-secondary-800">
                            {i + 1}
                          </span>
                          <span>{sol}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}